const translations = {
  cta: "Send feedback"
};

export default translations;
